<div class="messenger-wrapper">
    <div class="chat-wrapper" opened="false">
        <!-- hide title wrapper - PAVE-5599 -->
        <!-- <div class="title-wrapper">
            <img
                [src]="chatbotAvatar"
                alt="Chatbot-Avatar"
                (click)="openMenu()"
                style="cursor: pointer; width: 48px; height: 48.15px"
            />
            <img
                src="assets/images/icons/Chatbot_Dropdown.png"
                alt="Chatbot-Dropdown"
                (click)="openMenu()"
                style="padding: 0px 15px 0px 10px; cursor: pointer"
            />
            <div id="dfTitlebar">
                {{ pageData["MAIN_TITLE"] | translate }}
                <div class="tw-text-[18px] tw-text-[#4b6eec]"></div>
                <div class="tw-text-[14px] tw-text-[#003a70]">
                    {{ pageData["SUB_TITLE"] | translate }}
                </div>
            </div>
            <div
                id="dfTitlebar"
                (click)="closeChatbot()"
                class="tw-flex sm:tw-flex md:tw-hidden"
            >
                X
            </div>
        </div> -->
        <div
            id="menu"
            class="tw-w-[100%] tw-absolute tw-h-auto tw-hidden tw-bg-[#003a70] tw-justify-start tw-rounded-[20px] tw-py-[0px] tw-px-[15px] tw-shadow-[0_0_6px_0_rgba(0,0,0,0.16)]"
        >
            <div class="tw-flex tw-pt-[30px] tw-px-[15px] tw-justify-between">
                <div class="tw-text-white tw-text-[16px]">
                    {{ pageData["MENU"] | translate }}
                </div>
                <img
                    class="tw-cursor-pointer"
                    src="assets/images/icons/Chatbot_Close.png"
                    alt="Close-Chatbot"
                    (click)="closeMenu()"
                />
            </div>
            <div class="tw-text-[12px] tw-text-white tw-pt-[30px] tw-px-[15px]">
                {{ pageData["LANGUAGE"] | translate }}
            </div>
            <div
                (click)="changeLanguage('en')"
                class="tw-text-[16px] tw-cursor-pointer tw-text-white tw-pt-[20px] tw-px-[15px]"
            >
                {{ "CHATBOT.EN_UK" | translate }}
            </div>
            <div
                (click)="changeLanguage('bm')"
                class="tw-text-[16px] tw-cursor-pointer tw-text-white tw-pt-[20px] tw-px-[15px]"
            >
                {{ "CHATBOT.BM_MY" | translate }}
            </div>
            <div class="tw-text-[12px] tw-text-white tw-pt-[30px] tw-px-[15px]">
                {{ pageData["DECLARATION"] | translate }}
            </div>
            <div
                (click)="privacySecurity()"
                class="tw-text-[16px] tw-cursor-pointer tw-text-white tw-pt-[20px] tw-px-[15px]"
            >
                {{ pageData["PRIVACY_POLICY_SAFETY"] | translate }}
            </div>
            <div
                (click)="terms()"
                class="tw-text-[16px] tw-cursor-pointer tw-text-white tw-pt-[20px] tw-px-[15px]"
            >
                {{ pageData["TERMS_OF_USE"] | translate }}
            </div>
            <div class="tw-text-[12px] tw-text-white tw-pt-[30px] tw-px-[15px]">
                {{ pageData["LOCATION"] | translate }}
            </div>
            <div
                (click)="locationBtn()"
                style="
                    font-size: 16px;
                    cursor: pointer;
                    color: rgb(255, 255, 255);
                    font-family: &quot;Figtree&quot;, sans-serif !important;
                    padding: 20px 15px;
                "
            >
                {{ pageData["CGC_LOCATION"] | translate }}
            </div>
        </div>
        <iframe
            *ngIf="trustedUrl"
            [src]="trustedUrl"
            width="100%"
            height="100%"
            title="Chatbot-Modal"
            (load)="onIframeLoad()"
        ></iframe>
    </div>
    <button id="widgetIcon" (click)="chatbot()">
        <img class="chat-icon" [src]="chatbotAvatar" alt="Chatbot-Avatar" />
        <div id="closeIcon" class="">
            <svg
                id="closeSvg"
                height="30"
                viewBox="0 0 24 24"
                width="30"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                ></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </button>
</div>
